function setAnnouncementBarHeight() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  requestAnimationFrame(() => {
    const height = bar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    console.log('announceHeight', height);
  });
}
 
// initial
setAnnouncementBarHeight();

// recalc on resize (debounced)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(setAnnouncementBarHeight, 150);
});
 

// SHOPIFY CHAT HACK
function openShopifyInbox() {
  const host = document.querySelector('inbox-online-store-chat'); 
  const button = host?.shadowRoot?.querySelector('[data-spec="toggle-button"]');
  button?.click();
}
 
 
function toggleShopifyAgent() {
  const agent = document.querySelector('shopify-agent');
  if (!agent) return;

  const isOpen = agent.hasAttribute('open');
  if (isOpen) {
    agent.removeAttribute('open');
  } else {
    agent.setAttribute('open', '');
  }
}
